import { useEffect } from "react";
import Cookies from "js-cookie";
import constants from "../../constants/constants";
import APIUtils from "../../api/APIUtils";
import WebLinks from "../../api/WebLinks";

const IntercomMessenger = () => {
  useEffect(() => {
    const buyerId = Cookies.get(constants.COOKIE_LOGGED_BUYER_ID);
    const isSelfService = Cookies.get(constants.COOKIE_IS_SELFSERVICE);
    const isHireIntelligenceAdmin = Cookies.get(constants.COOKIE_IS_ADMIN);
    const isHiSuperAdmin = Cookies.get(constants.COOKIE_IS_SUPERADMIN);
    const intercomAppId = process.env.REACT_APP_INTERCOM_APP_ID || "cb6pts6h";
    const intercomApiBase = process.env.REACT_APP_INTERCOM_API_BASE || "https://api-iam.eu.intercom.io";

    const canUseIntercom = [isSelfService, isHireIntelligenceAdmin, isHiSuperAdmin].includes("true");
    if (!canUseIntercom || !buyerId || !intercomAppId || typeof window === "undefined") {
      return;
    }

    let isMounted = true;
    let isBooted = false;

    const getBuyerDetails = async () => {
      const response = await APIUtils.apiCall("GET", WebLinks.GetBuyerDetails + buyerId);
      const buyer = response.resultObj?.data;

      if (!isMounted || response.isCatch || response.resultObj?.statusCode !== "2000" || !buyer) {
        return;
      }
      let id=buyer.buyerId || buyerId;
      const tokenResponse = await APIUtils.apiCall("GET", WebLinks.GetIntercomToken + id);
      const intercomToken = tokenResponse.resultObj?.token || tokenResponse.resultObj?.data?.token;

      if (!isMounted || tokenResponse.isCatch || !intercomToken) {
        return;
      }

      const intercomConfig = {
        app_id: intercomAppId,
        ...(intercomApiBase ? { api_base: intercomApiBase } : { api_base: "https://api-iam.eu.intercom.io" }),
        user_id: String(buyer.buyerId || buyerId),
        name: buyer.name,
        email: buyer.email,
        intercom_user_jwt: intercomToken,
        ...(buyer.company_id ? {
          company: {
            company_id: buyer.company_id,
            name: buyer.masterName,
          },
        } : {}),
      };

      const bootIntercom = () => {
        if (!isMounted || typeof window.Intercom !== "function") {
          return;
        }

        window.Intercom("boot", intercomConfig);
        isBooted = true;
      };

      if (typeof window.Intercom === "function") {
        bootIntercom();
        return;
      }

      const script = document.createElement("script");
      script.src = `https://widget.intercom.io/widget/${intercomAppId}`;
      script.async = true;
      script.onload = bootIntercom;
      document.head.appendChild(script);
    };

    getBuyerDetails();

    return () => {
      isMounted = false;
      if (isBooted && typeof window.Intercom === "function") {
        window.Intercom("shutdown");
      }
    };
  }, []);

  return null;
};

export default IntercomMessenger;